import CONSTANTS from "../../assets/js/Constants"

const account = {}
export default function(state = account, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.ACCOUNT.SET_ACCOUNT:
         return { ...state, ...payload }

      case CONSTANTS.ACTION.ACCOUNT.UPDATE_ACCOUNT:
         return { ...state, ...payload }

      case CONSTANTS.ACTION.ACCOUNT.DELETE_ACCOUNT:
         return {}
      default:
         return { ...state }
   }
}
